// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"836ec810","498":"2e1067d0","646":"33565aab"}[chunkId] + ".chunk.js";
};